import { render, staticRenderFns } from "./merchantSetting.vue?vue&type=template&id=50f251f6&"
import script from "./merchantSetting.vue?vue&type=script&lang=js&"
export * from "./merchantSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports